import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class PageTitle extends React.PureComponent<PageTitle.Props, PageTitle.State> {
  public static sectionId = 'pagetit';

  public render(): JSX.Element {
    const { data, section } = this.props
    const { settings } = section
    const { imagedesktop } = settings
    const mobileImage = settings.imagemobile ? settings.imagemobile : settings.imagedesktop
    const {title} = settings
    const color = settings.textcolor
    const desktopRatio = settings.desktopratio ? settings.desktopratio : '3:1'
    return (
      <section className={'dynamic-page-title'}>
        <div className={'w-full relative mx-auto'}>
          <Snippets.Image
            alt={title}
            ratio={desktopRatio}
            className={'absolute inset-0 hidden md:block'}
            src={imagedesktop}
            preventLazy
          />
          <Snippets.Image
            alt={title}
            ratio={'1:1'}
            className={'absolute inset-0 block md:hidden'}
            src={mobileImage}
            preventLazy
          />
          {title ? (
            <div className={'absolute inset-0 flex z-10 mx-auto w-full pt-11 pb-11 justify-center items-center'}>
              <div className={'w-full md:w-1/2 max-w-md'}>
                <Snippets.Heading
                  size={'h1'}
                  tag={'h2'}
                  className={`text-center ${color === 'white' ? 'text-white' : 'text-black'}`}
                >
                  {title}
                </Snippets.Heading>
              </div>
            </div>
          ) : null}
        </div>
      </section>
    )
  }
}

export namespace PageTitle {
  export interface Options extends ShopifyNext.Section<{
    title?: string;
    imagedesktop?: string;
    imagemobile?: string;
    textcolor: 'white' | 'black';
    desktopratio: string;
  }> {
    block_size: number;
  }
  export interface Props extends GlobalProps {
    section: PageTitle.Options;
  }
  export interface State { }
}
